export default __webpack_public_path__ + "static/media/identity.6bf26d20.svg";